export const SET_CASE_DETAIL_SUCCESS = '[SET][CASE] details';
export const SET_CASE_HEADER_DETAIL_SUCCESS = '[SET][CASE] case data header';
export const SET_CASE_SUBMIT_SUCCESS = '[SET][CASE] submitted';
export const GET_QUESTIONNAIRE_CARD = 'questionnaireTypes/GET_QUESTIONNAIRE_CARD';
export const SET_QUESTIONNAIRE_CARD = 'questionnaireTypes/SET_QUESTIONNAIRE_CARD';
export const GET_QUESTIONNAIRE_PAGE = 'questionnaireTypes/GET_QUESTIONNAIRE_PAGE';
export const SET_QUESTIONNAIRE_PAGE = '[SET][QUESTIONNAIRE] page';
export const SET_QUESTIONNAIRE_MENU = '[SET][QUESTIONNAIRE] menu';
export const RESET_QUESTIONNAIRE = 'questionnaireTypes/RESET_QUESTIONNAIRE';
export const REFRESH_MENUS = 'questionnaireTypes/REFRESH_MENUS';
export const SET_MENU_INDEX = 'questionnaireTypes/SET_MENU_INDEX';
export const SET_SPINNER_STATUS = 'questionnaireTypes/SET_SPINNER_STATUS';
export const GET_QUESTIONNAIRE_PROFILE_SUCCESS = 'questionnaireTypes/GET_QUESTIONNAIRE_PROFILE_SUCCESS';
export const SET_SHOW_PROFILE_ICONNAME_STATE = 'questionnaireTypes/SET_SHOW_PROFILE_ICONNAME_STATE';
export const SET_TASK_DOCUMENT_DISABLED_STATUS = 'questionnaireTypes/SET_TASK_DOCUMENT_STATUS';
export const SET_PAGE_DATA = '[PAGE][DATA] page reset';
export const SET_RELOAD_ON_TOGGLE = '[SET][RELOAD_ON_TOGGLE] page reset';
export const RESET_IS_RELOADED = '[SET][RESET_IS_RELOADED] page reset';
export const SET_REFRESH_ON_PAGE = '[SET][SET_REFRESH_ON_PAGE] page refresh';
